import projeto1 from '@images/projects/project1.png'
import projeto2 from '@images/projects/project2.png'
import projeto3 from '@images/projects/project3.png'
import projeto4 from '@images/projects/project4.png'

export default [
  {
    title: "CASE_ONE_TITLE",
    image: projeto1,
    description: "CASE_ONE_DESCRIPTION",
    articles: [
      {
        description: 'CASE_ONE_ARTICLE_ONE_TITLE',
      },
    ],
    link: 'https://maismilhas.com.br/'
  },
  {
    title: "CASE_TWO_TITLE",
    image: projeto3,
    description: "CASE_TWO_DESCRIPTION",
    articles: [
      {
        description: 'CASE_TWO_ARTICLE_ONE_TITLE',
      }
    ],
    link: "https://zabbix.report/"
  },
  {
    title: "CASE_THREE_TITLE",
    image: projeto2,
    description: "CASE_THREE_DESCRIPTION",
    articles: [
      {
        description: 'CASE_THREE_ARTICLE_ONE_TITLE',
      }
    ],
    link: "http://easyinstitute.com.br/#/"
  },
  {
    image: projeto4,
    title: "CASE_FOUR_TITLE",
    description: "CASE_FOUR_DESCRIPTION",
    articles: [
      {
        description: 'CASE_FOUR_ARTICLE_ONE_TITLE',
      }
    ],
    link: "https://share.dev.br/"
  },
]
